export const TRANS = {
  attention: {
    en: 'Attention',
    fi: 'Huomio',
  },
};
